import { path } from 'ramda'

export const getIsResetting = path(['auth', 'resetting'])
